import type { EntryPoint } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type DropdownFixtureComponent from '../dropdown-ui';

export const loadingDropdownEntryPoint: EntryPoint<typeof DropdownFixtureComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<typeof DropdownFixtureComponent>(
			// Intentionally unresolved so the documentation keeps showing the loading state.
			() => new Promise<typeof DropdownFixtureComponent>(() => undefined),
			{ moduleId: 'constellation-loading-dropdown-entry-point' },
		),
		getPreloadProps: () => ({}),
	});
